import { render, staticRenderFns } from "./addAtmosphere.vue?vue&type=template&id=28f91759&scoped=true&"
import script from "./addAtmosphere.vue?vue&type=script&lang=js&"
export * from "./addAtmosphere.vue?vue&type=script&lang=js&"
import style0 from "./addAtmosphere.vue?vue&type=style&index=0&id=28f91759&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f91759",
  null
  
)

export default component.exports